import { useEffect, useState } from 'react';
import PricingCalculator from '../calculator/PricingCalculator';
import { CampaignWizard } from '../components/CampaignWizard/CampaignWizard';

export default function Calculator() {
  const [isBrandUser, setIsBrandUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/auth/me', { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          setIsBrandUser(!!data.brandId);
        }
      } catch (error) {
        console.error('Error checking user type:', error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return (
      <div className="h-full bg-background flex items-center justify-center">
        <div className="text-slate-500">Loading...</div>
      </div>
    );
  }

  // Brand users see the Campaign Builder, admins see the original calculator
  if (isBrandUser) {
    return <CampaignWizard />;
  }

  return (
    <div className="h-full bg-background">
      <PricingCalculator />
    </div>
  );
}

